import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LANGUAGE_LABELS, APP_LANGUAGE } from '../../shared/enums';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = (localStorage.getItem('language')?.toLowerCase() as APP_LANGUAGE) || APP_LANGUAGE.EN;

    if (req.url.startsWith(environment.baseUrl)) {
      const modifiedReq = req.clone({
        setHeaders: { Language: LANGUAGE_LABELS[lang] || APP_LANGUAGE.EN }
      });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
